import { render, staticRenderFns } from "./TabDevices.vue?vue&type=template&id=2dce5391&scoped=true"
import script from "./TabDevices.vue?vue&type=script&lang=js"
export * from "./TabDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce5391",
  null
  
)

export default component.exports